import React from "react";
import {
  FaYoutube,
  FaWhatsapp,
  FaFacebook,
  FaInstagram,
  FaXTwitter,
} from "react-icons/fa6";

const About = () => {
  return (
    <main className="min-h-screen bg-[#1e4ed8] flex justify-center px-1 py-1">
      <div className="w-full max-w-[430px] bg-[#e9e9e9] rounded-[16px] p-3 space-y-4">

        {/* CTA Section */}
        <section className="bg-blue-600 text-white text-center py-8 px-4 rounded-[16px]">
          <h2 className="text-[22px] font-bold mb-2">
            Try Courier World Now
          </h2>
          <p className="text-sm mb-2">
            Book your first parcel and experience fast, reliable delivery.
          </p>
          <p className="text-sm mb-4">
            Deliveries across 200+ countries.
          </p>

          <a href="tel:9959971831">
            <button className="bg-white text-blue-600 px-6 py-2 rounded-full font-semibold hover:bg-blue-100 transition active:scale-95">
              Book Now
            </button>
          </a>
        </section>

        {/* Highlights */}
        <section className="bg-white rounded-[16px] p-5 space-y-6">
          <div className="text-center">
            <img src="/secure.png" alt="Secure" className="mx-auto w-16 h-16 mb-2" />
            <h3 className="text-[16px] font-semibold text-blue-700">
              Secure Handling
            </h3>
            <p className="text-gray-600 text-sm">
              Your parcels are safe with us, from pickup to delivery.
            </p>
          </div>

          <div className="text-center">
            <img src="/tracking.png" alt="Tracking" className="mx-auto w-16 h-16 mb-2" />
            <h3 className="text-[16px] font-semibold text-blue-700">
              Real-time Tracking
            </h3>
            <p className="text-gray-600 text-sm">
              Track your shipment every step of the way, live.
            </p>
          </div>
        </section>

        {/* Social Media */}
        <section className="bg-white rounded-[16px] p-5 text-center">
          <h3 className="text-[18px] font-bold text-blue-800 mb-4">
            Connect with us
          </h3>

          <div className="flex justify-center gap-5 text-2xl">
            <a href="https://www.youtube.com/@COURIERWORLD" target="_blank" rel="noopener noreferrer">
              <FaYoutube className="text-red-500 hover:scale-110 transition" />
            </a>

            <a href="https://wa.me/919959971831" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp className="text-green-500 hover:scale-110 transition" />
            </a>

            <a href="https://www.facebook.com/courierworld.9170" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="text-blue-600 hover:scale-110 transition" />
            </a>

            <a href="https://www.instagram.com/courierworld_917/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="text-pink-500 hover:scale-110 transition" />
            </a>

            <a href="https://x.com/courierworld917" target="_blank" rel="noopener noreferrer">
              <FaXTwitter className="text-gray-700 hover:scale-110 transition" />
            </a>
          </div>
        </section>

        {/* FAQs */}
        <section className="bg-white rounded-[16px] p-5">
          <h3 className="text-[18px] font-bold text-blue-700 mb-4 text-center">
            FAQs
          </h3>

          <div className="space-y-3">
            <details className="border border-gray-200 rounded-xl p-4">
              <summary className="cursor-pointer font-medium text-blue-700">
                How much does shipping cost?
              </summary>
              <p className="text-gray-600 mt-2 text-sm">
                Shipping costs vary based on destination and parcel weight. Contact us for a quote.
              </p>
            </details>

            <details className="border border-gray-200 rounded-xl p-4">
              <summary className="cursor-pointer font-medium text-blue-700">
                What items can I ship?
              </summary>
              <p className="text-gray-600 mt-2 text-sm">
                You can ship food, documents, electronics, clothing, and more. Restricted items apply.
              </p>
            </details>

            <details className="border border-gray-200 rounded-xl p-4">
              <summary className="cursor-pointer font-medium text-blue-700">
                Do you offer pickup service?
              </summary>
              <p className="text-gray-600 mt-2 text-sm">
                Yes! We offer doorstep pickup via WhatsApp booking or phone call.
              </p>
            </details>
          </div>
        </section>

      </div>
    </main>
  );
};

export default About;